<template>
  <el-form-item>
    <el-date-picker
      v-model="dataObj"
      :type="type"
      :start-placeholder="startPlaceholder"
      :end-placeholder="endPlaceholder"
      size="small"
      @change="change"
    />
  </el-form-item>
</template>

<script>
import Util from "@/utils/index.js";

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: Object,
    field: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "daterange",
    },
    startPlaceholder: {
      type: String,
      default: "",
    },
    endPlaceholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataObj: "",
    };
  },
  methods: {
    change() {
      if (this.dataObj === "" || this.dataObj == null) {
        this.value[this.field + "StartAt"] = null;
        this.value[this.field + "EndAt"] = null;
        return;
      }

      if (this.type === "daterange") {
        this.value[this.field + "StartAt"] = Util.formatDate(this.dataObj[0]);
        this.value[this.field + "EndAt"] = Util.formatDate(this.dataObj[1]);
      } else {
        this.value[this.field + "StartAt"] = Util.formatDateTimeYMDHMS(
          this.dataObj[0]
        );
        this.value[this.field + "EndAt"] = Util.formatDateTimeYMDHMS(
          this.dataObj[1]
        );
      }
    },
  },
};
</script>
